import { CommonModule, DOCUMENT, DatePipe, Location, NgFor, NgIf, NgStyle } from "@angular/common";
import { AfterViewChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, Renderer2, TransferState, ViewChild, makeStateKey } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, NavigationEnd, Router, RouterLink } from "@angular/router";
import { IconCommentsComponent } from "@src/app/components/svg/icon-comments/icon-comments.component";
import { IconPauseComponent } from "@src/app/components/svg/icon-pause/icon-pause.component";
import { IconPlayComponent } from "@src/app/components/svg/icon-play/icon-play.component";
import { Noticia } from "@src/app/models/interfaces/noticia.interface";
import { DetalleNoticiasService } from "@src/app/servicios/detalle-noticias/detalle-noticias.service";
import { DeviceService } from "@src/app/servicios/device/device.service";
import { ReelsService } from "@src/app/servicios/reels.service";
import { Subscription, filter, first, firstValueFrom, map } from "rxjs";
import { ConfigService } from "src/app/servicios/config/config.service";
import { GfkService } from "src/app/servicios/gfk/gfk.service";
import { PlatformService } from "src/app/servicios/platform/platform.service";
import { TitleWrapperService } from "src/app/servicios/title-wrapper/title-wrapper.service";
import { DownArrowSvgComponent } from "../../components/svg/arrow-down/arrow-down.component";
import { KebabCasePipe } from "../../pipes/kebab-case.pipe";
import { StripHtmlPipe } from "../../pipes/striphtml/strip-html.pipe";
import { NoticiasService } from "../../servicios/noticias/noticias.service";
import { PublicidadService } from "../../servicios/publicidad/publicidad.service";
import { SeoService } from "../../servicios/seo/seo.service";
import { BannerAppMvComponent } from "../banner-app-mv/banner-app-mv.component";
import { FilaCuatroColumnasComponent } from "../bloques-filas/fila-cuatro-columnas/fila-cuatro-columnas.component";
import { NoticiasHorizontalComponent } from "../bloques-filas/noticias-horizontal/noticias-horizontal.component";
import { CommentaryBoxComponent } from "../comentarios/commentary-box.component";
import { ReelsLoaderComponent } from "../reels-loader/reels-loader.component";
import { RrssButtonsComponent } from "../rrss-buttons/rrss-buttons/rrss-buttons.component";
import { SkeletonImageComponent } from "../skeleton-image/skeleton-image/skeleton-image.component";
import { BloqueEnlacesNoticiasComponent } from "./bloque-enlaces-noticias/bloque-enlaces-noticias.component";
import { IntersectionScrollDirective } from "./intersection-scroll.directive";
import { NextPrevComponent } from "./next-prev/next-prev.component";
import { TipoNoticiaGenericoComponent } from "./tipo-noticia-generico/tipo-noticia-generico.component";
import { FooterService } from "@src/app/servicios/footer.service";
import { MatDialog } from "@angular/material/dialog";
import { TaboolaService } from "@src/app/servicios/publicidad/taboola.service";
import { TaboolaLazyDirective } from "@src/app/servicios/publicidad/taboola-lazy.directive";

/**
 * Clave para el estado de transferencia (SSR).
 */
const POST_KEY = makeStateKey<Noticia>("noticia");

/* No he quitado el MatButtonModule, ni el MattCardModule, porque no he encontrado donde se usen para poder reemplazarlos por css */
@Component({
  selector: "app-detalle-noticia",
  templateUrl: "./detalle-noticia.component.html",
  styleUrls: ["./detalle-noticia.component.css"],
  imports: [CommonModule, BannerAppMvComponent, BloqueEnlacesNoticiasComponent, CommentaryBoxComponent, DatePipe, FilaCuatroColumnasComponent, NoticiasHorizontalComponent, KebabCasePipe, MatButtonModule, MatCardModule, NgStyle, RouterLink, TipoNoticiaGenericoComponent, NextPrevComponent, RrssButtonsComponent, IntersectionScrollDirective, ReelsLoaderComponent, DownArrowSvgComponent, IconCommentsComponent, SkeletonImageComponent, IconPlayComponent, IconPauseComponent, NgIf, NgFor, TaboolaLazyDirective],
  providers: [DetalleNoticiasService, TaboolaService],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetalleNoticiaComponent implements OnInit, OnDestroy, AfterViewChecked {
  noticia: Noticia;
  secureDescription: SafeHtml = "";
  accentColor: string = "#000";
  btnPauseTTS = false;
  btnPlayTTS = true;
  nextPrevNoticias: any;
  rrssAbajo: boolean;

  noticiasRelacionadas: any[] = [];
  ultimosVideos: any[] = [];
  ultimosVideosSeccion: any[] = [];
  videosMasVisto: any[] = [];
  comentariosNoticia: any[] = [];
  detalleReelsEnabled: boolean = false;
  showKeepScrolling: boolean = false;
  isReels: boolean = false;

  constantesGlobales: any; // Contantes globales de configuración
  canalCanonico: any;

  isPremium = 0;

  private observer: IntersectionObserver;

  @ViewChild("contenedorNoticia") contenedorNoticia: ElementRef<HTMLDivElement>;

  gfkSub: Subscription;
  isMobile: boolean = false; // Indica si se está en un dispositivo móvil
  showDivVideoAbajo = true;
  isWebView = false; // Indica si se está en una WebView.
  rSub: Subscription;

  constructor(
    private readonly activatedRoute: ActivatedRoute,
    private readonly noticiasService: NoticiasService,
    private readonly configService: ConfigService,
    private readonly detalleNoticiasService: DetalleNoticiasService,
    private readonly router: Router,
    private readonly renderer2: Renderer2,
    @Inject(DOCUMENT) private readonly document: any,
    private readonly platformService: PlatformService,
    private readonly sanitizer: DomSanitizer,
    private readonly kebabPipe: KebabCasePipe,
    private readonly seoService: SeoService,
    public publiService: PublicidadService,
    private readonly stripHtml: StripHtmlPipe,
    private readonly deviceService: DeviceService,
    private readonly titleWrapperService: TitleWrapperService,
    private readonly gfkService: GfkService,
    private readonly transferState: TransferState,
    private readonly location: Location,
    private readonly reelsService: ReelsService,
    private readonly cd: ChangeDetectorRef,
    private readonly footerService: FooterService,
    private taboolaService: TaboolaService,
    public dialog: MatDialog,
  ) {
    // Oculta orientación en reels.
    this.reelsService.sethideOrientation(true);
    this.constantesGlobales = this.configService.getConstantesGlobales();
    this.rrssAbajo = false;

    // Verifica si existe SpeechSynthesis en navegador
    if (this.platformService.isBrowser() && window.speechSynthesis) {
      window.speechSynthesis.cancel();
    }
  }

  /**
   * ngOnInit:
   * - Detecta si el dispositivo es móvil.
   * - Configura reels y obtiene colores globales.
   * - Inicia GFK si aplica.
   */
  ngOnInit(): void {
    this.footerService.isPaginationFinished.set(true);
    const deviceServiceMobile = this.deviceService.isMobile();
    if (deviceServiceMobile) {
      firstValueFrom(deviceServiceMobile).then((isMobile) => {
        this.isMobile = isMobile;
        if (this.isMobile) {
          this.isWebView = this.isInAndroidWebView() || this.isInIOSWebView();
        }
      });
    }

    // Suscribirse a data en la ruta
    this.activatedRoute.data.subscribe({
      next: ({ videoData }) => {
        if (!videoData.video) {
          this.router.navigate(["404"]);
          return;
        }
        this.comentariosNoticia = videoData.comentarios;
        this.ultimosVideosSeccion = videoData.ultimasNoticiasSeccion;
        this.nextPrevNoticias = videoData.nextPrev;
        this.noticiasRelacionadas = videoData.relacionadas;
        this.getNoticia(videoData);
      },
      error: () => {
        this.router.navigate(["404"]);
      },
    });
    // Suscripción a cambios de ruta
    this.rSub = this.activatedRoute.params.subscribe((parms: any) => {
      if (parms.id) {
        const lastNews = this.noticiasService.getTotalUltimasNoticias();
        if (lastNews) {
          lastNews.pipe(first()).subscribe((result) => {
            if (result != null) {
              this.ultimosVideos = result.slice(0, 5);
            }
          });
        }
        // Filtra y mantiene los primeros 5 videos más vistos (únicos por ID)
        const mostWatchVideo = this.noticiasService.getVideosMasVistos();
        if (mostWatchVideo) {
          mostWatchVideo
            .pipe(
              first(),
              map((result) => {
                const uniqueItems = Array.from(
                  result
                    .reduce((map, item) => {
                      if (!map.has(item.idVideo)) {
                        map.set(item.idVideo, item);
                      }
                      return map;
                    }, new Map())
                    .values(),
                );
                return uniqueItems.slice(0, 5);
              }),
            )
            .subscribe((uniqueTop5) => {
              this.videosMasVisto = uniqueTop5;
            });
        }
      }
    });

    // Config de prensa
    const configPrensa = this.configService.getConfigPrensa();
    if (configPrensa) {
      firstValueFrom(configPrensa).then((resultConfig) => {
        const generalConstants = resultConfig.general;
        this.detalleReelsEnabled = generalConstants["app-home-reels"]["detalle-noticia-reels"] === "true";
        if (this.detalleReelsEnabled) {
          this.showKeepScrolling = generalConstants["app-home-reels"]["keep_scrolling_text"] === "true";
          this.reelsService.getIsReels().subscribe((isReels) => (this.isReels = isReels));
        }
        this.setCssColors(generalConstants["global-constants"]);
      });
    }

    // Inicia GFK si está activado
    if (this.constantesGlobales.gfk === true && this.platformService.isBrowser()) {
      this.initGfk();
    }

    // Inicializar Taboola si se cambia de una noticia a otra
    this.taboolaService.reloadPushTaboola();
  }

  /**
   * Obtiene la noticia y actualiza la información local y de SEO.
   * @param videoData Datos de la noticia (video, comentarios, etc.)
   */
  getNoticia(videoData): void {
    const video = videoData.video;
    if (!this.platformService.isBrowser()) {
      this.fetchNoticiaAndStoreKey(video);
    } else {
      const news = this.transferState.get<any>(POST_KEY, null);
      if (this.transferState.hasKey(POST_KEY) && news.idVideo === video.idVideo) {
        this.setNews(news);
        this.transferState.remove(POST_KEY);
      } else {
        this.fetchNoticiaAndStoreKey(videoData.video);
      }
    }
    const urlFrom = this.activatedRoute.snapshot.params.id3;
    if (!urlFrom) {
      this.validarUrl(this.noticia);
    }

    const title = this.noticia.tituloVideo + " - " + this.constantesGlobales.siteName;
    this.setDocTitle(title);
  }

  /**
   * Obtiene la noticia desde el SSR o servidor, inserta contenedores de publicidad en el texto,
   * y actualiza el estado local y de transferencia.
   * @param result Datos de la noticia.
   */
  fetchNoticiaAndStoreKey(result): void {
    result.descripcionVideo = this.publiService.insertHtmlPubliContainers(result.descripcionVideo);
    this.setNews(result);
    this.transferState.set(POST_KEY, this.noticia);
  }

  /**
   * Actualiza la noticia en el componente y configura SEO, URLs, etc.
   * @param news Datos de la noticia a establecer.
   */
  setNews(news): void {
    if (!news) {
      this.router.navigate(["404"]);
      return;
    }
    this.secureDescription = this.sanitizer.bypassSecurityTrustHtml(news.descripcionVideo);
    this.noticia = news;

    if (this.isMobile && this.noticia.posicion_video == "2") {
      this.showDivVideoAbajo = false;
    }

    this.seoService.insertaScriptNoticia(this.noticia);
    this.isPremium = news.esPremium;

    const idVideo = news.idVideo;
    this.setNewsUrls(idVideo, news.tituloSeo, news.idCanonico, news.urlVideo);
    this.seoService.updateMetaTags(news, this.noticia.urlCanonica);

    if (this.noticia?.img_relacionadas?.indexOf(this.noticia.urlGenerica) === -1) {
      this.noticia?.img_relacionadas.unshift(this.noticia.urlGenerica);
    }

    if (this.platformService.isBrowser()) {
      this.registerView(idVideo);
    }
    this.cd.markForCheck();
  }

  /**
   * Configura las URLs limpias y canónicas de la noticia.
   * @param idVideo ID de la noticia.
   * @param tituloSeo Título SEO.
   * @param idCanonico Canonical ID.
   * @param urlVideo URL del video (para Dailymotion).
   */
  setNewsUrls(idVideo, tituloSeo, idCanonico, urlVideo): void {
    if (this.esDailymotion(urlVideo)) {
      this.noticia.urlLimpia = this.sanitizer.bypassSecurityTrustResourceUrl(urlVideo);
    }
    const slug = this.kebabPipe.transform(tituloSeo);
    const urlNoticia = this.constantesGlobales.siteDomain + "/noticias/" + idVideo + "/" + slug;
    this.canalCanonico = idCanonico;
    this.noticia.urlCanonica = urlNoticia;
    this.noticia.urlNoticia = urlNoticia;
  }

  /**
   * Registra una visita a la noticia si no está en localhost.
   * @param idVideo ID de la noticia.
   */
  registerView(idVideo): void {
    const host = this.platformService.getLocationHostname();
    if (host !== "localhost" && idVideo) {
      const registerVisit = this.detalleNoticiasService.registerVisita(idVideo, this.constantesGlobales.idAmbito);
      if (registerVisit) {
        firstValueFrom(registerVisit).then();
      }
    }
  }

  /**
   * Se ejecuta al destruir el componente:
   * - Cancela suscripciones,
   * - Limpia datos del SSR,
   * - Quita scripts de la noticia,
   * - Restaura la visibilidad de la orientación (reels).
   */
  ngOnDestroy(): void {
    if (this.rSub) this.rSub.unsubscribe();
    if (this.gfkSub) this.gfkSub.unsubscribe();
    this.seoService.borraScript("NewsArticleStructData");
    this.transferState.remove(POST_KEY);
    this.reelsService.sethideOrientation(false);
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  /**
   * Valida la URL de la noticia. Si no coincide el slug con el que corresponde,
   * redirecciona al correcto.
   * @param noticia Noticia a validar.
   */
  validarUrl(noticia): void {
    if (!noticia.idVideo && !noticia) {
      this.router.navigate(["404"]);
      return;
    }

    const url = this.platformService.getLocationPathname().split("/").pop();
    const slug = this.kebabPipe.transform(noticia.tituloSeo);
    if (url !== slug) {
      this.router.navigateByUrl("/noticias/" + noticia.idVideo + "/" + slug);
    }
  }

  /**
   * Aplica estilos de color a la raíz del documento.
   * @param globalConstants Objeto con colores globales.
   */
  setCssColors(globalConstants): void {
    if (globalConstants.accent_color) {
      this.renderer2.setProperty(this.document.documentElement, "style", "--accent-color:" + globalConstants.accent_color);
      this.accentColor = globalConstants.accent_color;
    }
  }

  /**
   * Comprueba si una URL pertenece a Dailymotion.
   * @param url URL a verificar.
   */
  esDailymotion(url): boolean {
    const regExp = /dailymotion.com/gi;
    return url?.search(regExp) !== -1;
  }

  /**
   * Establece el título del documento.
   * @param title Nuevo título a asignar.
   */
  setDocTitle(title: string): void {
    this.titleWrapperService.setTitle(title);
  }

  /**
   * Se ejecuta después de que la vista haya sido comprobada:
   * - Comprueba si se deben mostrar los botones de RRSS abajo.
   */
  ngAfterViewChecked(): void {
    this.checkRrssAbajo();
  }

  /**
   * Comprueba si el contenedor de la noticia supera cierto tamaño para decidir
   * si se muestran los botones de RRSS abajo.
   */
  checkRrssAbajo(): void {
    if (!this.platformService.isBrowser()) return;
    requestAnimationFrame(() => {
      const windowHeight = window.innerHeight;
      const divHeight = this.contenedorNoticia.nativeElement.offsetHeight;
      const shouldRrssAbajo = divHeight > windowHeight * 0.8;
      if (this.rrssAbajo !== shouldRrssAbajo) {
        this.rrssAbajo = shouldRrssAbajo;
      }
      this.cd.detectChanges();
    });
  }

  /**
   * Desplaza la ventana hasta la sección de comentarios.
   */
  scrollToComments(): void {
    if (!this.platformService.isBrowser()) return;
    const el = document.getElementById("publi-comentarios");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }

  /**
   * Inicializa GFK (mide audiencias) si se cumple la configuración y es un navegador real.
   */
  private initGfk(): void {
    const customParams = {
      c1: this.stripProtocolAndSubdomain(this.constantesGlobales.siteDomain),
      c2: "noticias",
    };
    if (this.platformService.isBrowser()) {
      this.gfkService.impression(customParams);
    }

    if (this.router?.events) {
      this.gfkSub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
        if (this.platformService.isBrowser()) {
          this.gfkService.impression(customParams);
        }
      });
    }
  }

  /**
   * Quita protocolo y subdominio (http/https, www) de la URL.
   * @param url URL a limpiar.
   */
  stripProtocolAndSubdomain(url: string): string {
    return url.replace(/^(https?:\/\/)?(www\.)?/, "");
  }

  /**
   * Detecta si se está en una WebView de Android.
   */
  isInAndroidWebView(): boolean {
    if (!this.platformService.isBrowser()) return false;
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /; wv/.test(userAgent);
  }

  /**
   * Detecta si se está en una WebView de iOS.
   */
  isInIOSWebView(): boolean {
    if (!this.platformService.isBrowser()) return false;
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIOS = /iphone|ipod|ipad/.test(userAgent);
    const notSafari = !/safari/.test(userAgent);
    const notStandalone = !("standalone" in window.navigator && window.navigator["standalone"]);
    return isIOS && notSafari && notStandalone;
  }

  /**
   * Al salir de los reels, actualiza la URL sin reels.
   */
  onReelsExit(): void {
    const slug = this.kebabPipe.transform(this.noticia.tituloSeo);
    this.location.go("/noticias/" + this.noticia.idVideo + "/" + slug);
  }

  /**
   * Convierte una fecha a ISO.
   * @param fecha Fecha a convertir.
   */
  dateToIso(fecha: any): string {
    // Manejo de valores nulos, undefined, vacíos o no válidos
    if (fecha == null || fecha === undefined || fecha === "" || typeof fecha === "undefined") {
      return null;
    }

    // Manejo de timestamps numéricos
    if (typeof fecha === "number" && !isNaN(fecha)) {
      const date = new Date(fecha);
      if (isNaN(date.getTime())) {
        return null;
      }
      return date.toISOString();
    }

    // Convertir a string si no es un número ni string
    let fechaStr: string;
    if (typeof fecha !== "string") {
      fechaStr = String(fecha);
    } else {
      fechaStr = fecha;
    }

    // Verificar si fechaStr es inválido después de la conversión
    if (!fechaStr || fechaStr === "undefined" || fechaStr === "null" || typeof fechaStr !== "string") {
      return null;
    }

    // Intentar normalizar la fecha reemplazando espacios por 'T'
    const normalizedDate = fechaStr.replace(/\s/g, "T");

    // Validar si la fecha es válida
    const date = new Date(normalizedDate);
    if (isNaN(date.getTime())) {
      return null;
    }

    // Devolver la fecha en formato ISO
    return date.toISOString();
  }

  /**
   * Reproduce el texto de la noticia usando SpeechSynthesis.
   * @param texto Texto a reproducir.
   */
  leerTexto(texto: string): void {
    if (!this.platformService.isBrowser()) return;
    texto = this.stripHtml.transform(texto);
    const utterance = new SpeechSynthesisUtterance(texto);
    utterance.volume = 1;
    if (window.speechSynthesis.paused) {
      window.speechSynthesis.resume();
    } else {
      window.speechSynthesis.speak(utterance);
    }
    this.btnPlayTTS = false;
    this.btnPauseTTS = true;
    utterance.onend = () => {
      this.btnPlayTTS = true;
      this.btnPauseTTS = false;
    };
  }

  /**
   * Pausa la reproducción del texto.
   */
  pausarTexto(): void {
    if (!this.platformService.isBrowser()) return;
    this.btnPlayTTS = true;
    this.btnPauseTTS = false;
    if (window.speechSynthesis.speaking) {
      window.speechSynthesis.pause();
    }
  }

  /**
   * Da formato a la fecha para transformarla en ISO.
   * @param obj Fecha a formatear.
   */
  formatDate(obj): string {
    if (obj == null) return null;
    return obj.toString().replace(/\s/g, "T");
  }

  autorUrl(): any[] {
    const autor = this.noticia;
    return autor ? ["/autor", autor.id_autor, this.kebabPipe.transform(autor.nombre_autor)] : [];
  }

  trackByTag(index: number, tag: any): string {
    return tag?.id ?? tag?.nombre_tag;
  }

  /**
   * Abre el diálogo de login (importación dinámica).
   */
  openLoginDialog(): void {
    import("../modal-login/modal-login.component").then(({ ModalLoginComponent }) => {
      this.dialog
        .open(ModalLoginComponent, {
          panelClass: "modal-login",
          maxWidth: "85%",
          minWidth: "50%",
        })
        .afterClosed()
        .subscribe(() => {
          // Resultado del diálogo
        });
    });
  }

  /**
   * Abre el diálogo de registro (importación dinámica).
   */
  openRegisterPage(): void {
    import("../modal-registro/modal-registro.component").then(({ ModalRegistroComponent }) => {
      this.dialog
        .open(ModalRegistroComponent, {
          panelClass: "modal-register",
        })
        .afterClosed()
        .subscribe(() => {
          // Resultado del diálogo
        });
    });
  }
}
